import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { LinkedService } from 'app/model/linkedservice/linkedservice';
import { ModelFetchUtils } from 'app/model/services/model.utils/model.fetch.utils';
import { containsParameter, containsExpressionObject } from 'app/shared/utils/expression.util';
import _ from 'lodash';

export class GenericLinkedServiceAdapter extends LinkedServiceAdapter<LinkedService> {
    protected skipProperties = true;

    public async toModel(linkedServiceResource: Model.LinkedServiceResource, linkedService?: LinkedService): Promise<LinkedService> {
        const model = ModelFetchUtils.getModelByResourceType('linkedService', linkedServiceResource.properties.type);
        if (!linkedService) {
            linkedService = model.create<LinkedService>(linkedServiceResource.name, linkedServiceResource.properties.description);
        }

        // With creating the linked service by above code and this.skipProperties = true, will ignore most logics in LinkedServiceAdapter._toModel
        // Use NamedAsyncAdapter._toModel for name/description
        // Use BaseAsyncAdapter.toModel to catch and log errors
        await super.toModel(linkedServiceResource, linkedService);

        if (containsParameter(linkedServiceResource) || containsExpressionObject(linkedServiceResource)) {
            linkedService.parameterized = true;
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        linkedService.setCachedResource(linkedServiceResource.properties != null && (linkedServiceResource.properties as any).typeProperties != null
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ? (linkedServiceResource.properties as any).typeProperties.encryptedCredential
            : undefined, linkedServiceResource);

        linkedService.raw = JSON.stringify(await ValueAdapter.remainder(
            this.context,
            linkedServiceResource,
            model));
        return linkedService;
    }

    public async toResource(linkedService: LinkedService): Promise<Model.LinkedServiceResource> {
        let linkedServiceResource = await super.toResource(linkedService) as Model.LinkedServiceResource;

        if (linkedService.encryptedCredential) {
            // Use the cached resource
            // Only description may be changed if there is encrypted credential
            linkedService.cachedResource.properties.description = linkedServiceResource.properties.description;
            return linkedService.getCachedResourceCopy();
        }

        const properties = this.properties(linkedServiceResource);
        const metaModel = Metamodel.modelOf(linkedService);
        properties.type = metaModel.tag('subType') || metaModel.name;
        properties.typeProperties = {};

        if (linkedService.raw) {
            const parsed = JSON.parse(linkedService.raw);
            _.merge(linkedServiceResource, parsed);
        }

        linkedServiceResource = await this.connectVia(linkedService, linkedServiceResource);

        return linkedServiceResource;
    }

    protected modelConstructor(): new () => LinkedService {
        throw new Error('Method not implemented.'); // No need to implement
    }
    protected model(): IModel {
        throw new Error('Method not implemented.'); // No need to implement
    }
    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: LinkedService): Promise<LinkedService> {
        throw new Error('Method not implemented.'); // No need to implement
    }

    protected async propertiesToResourceAsync(linkedService: LinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        throw new Error('Method not implemented.'); // No need to implement
    }
}
